module.exports = __webpack_public_path__ + "54367648c2f8272ff6a7a99d41a7d275.jpg";